var map = {
	"./card_bg_1.png": 97691,
	"./card_bg_2.png": 59008,
	"./card_bg_3.png": 13833,
	"./card_bg_4.png": 39574,
	"./card_bg_5.png": 17663,
	"./card_bg_6.png": 4100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34157;